import cn from 'classnames';
import { FC } from 'react';

import { isTrustedYandexMapWidgetSrc } from '../../utils';
import styles from './OfficeMap.module.scss';
import { OfficeMapProps } from './types';

const OfficeMap: FC<OfficeMapProps> = ({
    offices,
    loadedCities,
    activeCity,
    mapWidgetSrcByCity,
    isCompact = false,
}) => (
    <div className={cn(styles.officeMap_root, isCompact && styles.officeMap_compact)}>
        {offices.map(city => {
            const mapWidgetSrc = mapWidgetSrcByCity.get(city.id) || '';
            const hasTrustedMapWidgetSrc = isTrustedYandexMapWidgetSrc(mapWidgetSrc);
            const isMapUnavailable = !loadedCities.has(city.id) || !hasTrustedMapWidgetSrc;

            return isMapUnavailable ? null : (
                <iframe
                    key={city.id}
                    title={`Карта офиса: ${city.sales.title}`}
                    src={mapWidgetSrc}
                    className={city.id === activeCity ? styles.officeMap_frame : styles.officeMap_frameHidden}
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                />
            );
        })}
    </div>
);

export default OfficeMap;
